import { createI18n } from 'vue-i18n'

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      const loaded = locales(key)
      messages[locale] = loaded.default || loaded
    }
  })
  console.log(messages)
  return messages
}

// function detectLanguage() {
//   const lng = window.navigator.userLanguage || window.navigator.language;
//   const locales = require.context(
//     "./locales",
//     true,
//     /[A-Za-z0-9-_,\s]+\.json$/i
//   );
//   const lang = locales
//     .keys()
//     .find((key) => lng.includes(key.replace("./", "").replace(".json", "")));
//   return lang ? lang.replace("./", "").replace(".json", "") : null;
// }

export default createI18n({
  legacy: false,
  locale: localStorage.getItem("lang") ||
    process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ru',
  messages: loadLocaleMessages()
})
